import Typography from "component-lib/Base/components/Typography"
import { getWindow } from "utils-lib/getWindow"
import { Link } from "../../../Base"
import "./sevenCard.scss"

const ssrWindow = getWindow()

const Faqcard = (cardList) => {
  const bodyWidth =
    ssrWindow.innerWidth > 0 ? ssrWindow.innerWidth : ssrWindow.screen.width

  return (
    <div className="cardWrapper" data-testid="FaqCard">
      <div className="maax-font-weight-bold cardItemtitle">
        {cardList?.cardList?.cardEyebrowText}
      </div>
      <Typography
        className="flex-grow-1 cardItemsubText maax-font-weight-regular"
        variant={bodyWidth < 1025 ? "h4" : "h3"}
        style={{ color: "black" }}
      >
        {cardList?.cardList?.cardHeading}
      </Typography>
      <Link
        overrideClass="maax-font-weight-regular"
        href={cardList?.cardList?.cardCtaURL}
        analytics_key={
          cardList?.cardList?.analytics_key ||
          `${cardList?.cardList?.cardCtaText} ${cardList?.cardList?.cardCtaURL}`
        }
      >
        {cardList?.cardList?.cardCtaText}
      </Link>
    </div>
  )
}
export default Faqcard
